import i18n from './i18n'

const CHANNEL_NAME = 'cashier-pos-sync'

let channel = null

const log = (tag, ...args) => {
  console.log(`[SYNC][${tag}]`, new Date().toISOString(), ...args)
}

const getChannel = () => {
  if (!channel && typeof BroadcastChannel !== 'undefined') {
    channel = new BroadcastChannel(CHANNEL_NAME)
    log('INIT', 'BroadcastChannel created')
  }
  return channel
}

export const broadcastState = (checkoutState, { quiet = false } = {}) => {
  // Customer display follows the cashier's language
  const state = { ...checkoutState, language: i18n.language }
  const cartSummary = state.cart?.length
    ? `${state.cart.length} items, last: ${state.cart[state.cart.length - 1]?.title}`
    : 'empty cart'
  if (!quiet) log('BROADCAST', `modal=${state.currentModal} payment=${state.paymentStatus} cart=[${cartSummary}]`)

  const ch = getChannel()
  if (ch) {
    ch.postMessage({ type: 'STATE_UPDATE', payload: state })
    if (!quiet) log('BROADCAST', 'Sent via BroadcastChannel')
  } else {
    log('BROADCAST', 'No BroadcastChannel available')
  }
  // On Android, forward state to customer display via native bridge
  if (window.AndroidBridge?.syncCustomerState) {
    try {
      const json = JSON.stringify(state)
      window.AndroidBridge.syncCustomerState(json)
      if (!quiet) log('BROADCAST', `Sent via AndroidBridge (${json.length} bytes)`)
    } catch (e) {
      log('BROADCAST', 'AndroidBridge.syncCustomerState ERROR:', e.message)
    }
  }
}

export const onStateUpdate = (callback) => {
  const ch = getChannel()
  if (ch) {
    ch.onmessage = (event) => {
      if (event.data?.type === 'STATE_UPDATE') {
        const state = event.data.payload
        const cartSummary = state.cart?.length
          ? `${state.cart.length} items`
          : 'empty cart'
        log('RECEIVE', `BroadcastChannel STATE_UPDATE: cart=[${cartSummary}] modal=${state.currentModal}`)
        callback(state)
      }
    }
    log('LISTEN', 'Listening on BroadcastChannel')
  } else {
    log('LISTEN', 'No BroadcastChannel — will rely on AndroidBridge')
  }
  return () => {
    if (ch) ch.onmessage = null
  }
}
